import backendHttpClient from '../../../http/axios/axios-http-client';
import { UpdateAvailabilityRequestDTO } from './dto/request/update-availability-request.dto';
import { ConnectedCalendarResponseDTO } from './dto/response/connected-calendar-response.dto';
import { HealerAvailabilityResponse } from './dto/response/healer-availability-response.dto';

const SECURED_ENDPOINT = '/calendar';
const PUBLIC_ENDPOINT = '/public/calendar';

export interface CalendarGateway {
  getAuthorizationUrl(): Promise<string>;
  addOrReplaceCalendar(accessCode: string): Promise<void>;
  getConnectedCalendar(): Promise<ConnectedCalendarResponseDTO>;
  getMyAvailability(): Promise<HealerAvailabilityResponse>;
  updateAvailability(body: UpdateAvailabilityRequestDTO): Promise<void>;
  getBookingUrl(healerUserProfileId: string): Promise<string>;
}

export class CalendarGateway implements CalendarGateway {
  async getAuthorizationUrl(): Promise<string> {
    const endpoint = `${SECURED_ENDPOINT}/generate-authorization-url`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }

  async addOrReplaceCalendar(accessCode: string): Promise<void> {
    const endpoint = `${SECURED_ENDPOINT}/add-calendar?accessCode=${accessCode}`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'POST',
    });
    return response.data;
  }

  async getConnectedCalendar(): Promise<ConnectedCalendarResponseDTO> {
    const endpoint = `${SECURED_ENDPOINT}/connected-calendar`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }

  async getMyAvailability(): Promise<HealerAvailabilityResponse> {
    const endpoint = `${SECURED_ENDPOINT}/availability`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }

  async updateAvailability(body: UpdateAvailabilityRequestDTO): Promise<void> {
    const endpoint = `${SECURED_ENDPOINT}/availability`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: body,
    });
    return response.data;
  }

  async getBookingUrl(packageId: string): Promise<string> {
    const endpoint = `${PUBLIC_ENDPOINT}/${packageId}/booking-url`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }
}
